/* eslint-disable */

export { default as SeatsioSeatingChart } from './SeatsioSeatingChart';
